<template>
  <v-card rounded="lg" flat>
    <v-card-title class="subtitle-1 font-weight-bold"
      >Forma de Pagamento</v-card-title
    >
    <v-card-text>
      <v-row>
        <v-col xl="8" lg="8" md="8" cols="12">
          <v-form :disabled="novopedido.produtos.length > 0">
            <v-row>
              <v-col cols="12">
                <v-select
                  label="Condição de pgto"
                  no-data-text="Nenhuma condição de pgto encontrada"
                  :items="getCondPgtoFiltradas()"
                  item-text="condicao"
                  item-value="codigo"
                  v-model="novopedido.condicaoPgtoSelecionada"
                ></v-select>
                <template v-if="getCondicaoSelecionada()">
                  <v-select
                    label="Parcelas"
                    no-data-text="Nenhuma parcela disponível"
                    :items="getCondicaoSelecionada().parcelas"
                    v-model="novopedido.parcelaSelecionada"
                  ></v-select>
                  <template v-if="getCondicaoSelecionada().cartao">
                    <v-select
                      label="Tipo"
                      :items="getTipoCartao()"
                      v-model="novopedido.tipocartaoselec"
                      @change="novopedido.cartaoSelecionado = 0"
                      no-data-text="Nenhum tipo de cartão encontrado"
                    ></v-select>
                    <v-select
                      label="Bandeira"
                      :items="
                        config.cartoes.filter(
                          (c) => c.tipo == novopedido.tipocartaoselec
                        )
                      "
                      item-text="cartao"
                      item-value="cod"
                      v-model="novopedido.cartaoSelecionado"
                      :messages="txJurosCartao()"
                      class="mb-4"
                      no-data-text="Nenhum cartão encontrado"
                    ></v-select>
                  </template>
                  <v-text-field
                    label="Vcto inicial"
                    type="date"
                    v-model="novopedido.vctoinicial"
                    :disabled="!getCondicaoSelecionada().infvcto"
                  ></v-text-field>
                  <v-select
                    label="Conta corrente"
                    no-data-text="Nenhuma conta corrente disponível"
                    :items="getCtasCorrentes()"
                    item-text="descricao"
                    item-value="conta"
                    v-model="novopedido.contaSelecionada"
                    :disabled="!getCondicaoSelecionada().infctacorrente"
                  ></v-select>
                </template>
              </v-col>
            </v-row>
          </v-form>
        </v-col>
        <v-col xl="4" lg="4" md="4" cols="12">
          <v-card v-if="isMobile()" flat class="grey lighten-4" rounded="lg">
            <v-card-text>
              <v-row>
                <v-col cols="6">
                  <span class="font-weight-bold body-1">Parcela</span>
                </v-col>
                <v-col cols="6">
                  <span class="font-weight-bold body-1 float-right"
                    >Vencimento</span
                  >
                </v-col>
              </v-row>
              <template v-if="getParcelas().length > 0">
                <v-row v-for="(parc, i) in getParcelas()" :key="i" dense>
                  <v-col cols="6"
                    ><span class="subtitle-1">{{ parc.parc }}º</span></v-col
                  >
                  <v-col cols="6"
                    ><span class="float-right subtitle-1">{{
                      formatarData(parc.vcto)
                    }}</span></v-col
                  >
                </v-row>
              </template>
              <v-row v-else>
                <v-col>
                  <span class="text-center"><i>Nenhuma parcela gerada</i></span>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <v-card flat rounded="lg" color="grey lighten-4" height="100%" v-else>
            <v-card-text>
              <v-data-table
                hide-default-footer
                :items="getParcelas()"
                :headers="headers"
                no-data-text="Nenhuma parcela gerada"
                :disable-sort="isMobile()"
              >
                <template v-slot:[`item.vcto`]="{ item }">
                  {{ formatarData(item.vcto) }}
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import moment from "moment";
import { mapGetters, mapState } from "vuex";
export default {
  watch: {
    ["novopedido.tipoPedidoSelec"]: function () {
      this.atualizarCondPgto();
    },
    ["novopedido.cliente"]: function () {
      this.atualizarCondPgto();
    },
    ["novopedido.condicaoPgtoSelecionada"]: function () {
      this.novopedido.parcelaSelecionada =
        this.getCondicaoSelecionada().parcelas[0];
      if (!this.getCondicaoSelecionada().infvcto)
        this.novopedido.vctoinicial = this.getCondicaoSelecionada().vctoinicial;
      if (this.getCondicaoSelecionada().cartao) {
        this.novopedido.tipocartaoselec = "CREDITO";
      }
    },
  },
  computed: mapState("pedidos", ["config", "novopedido"]),
  data: () => ({
    headers: [
      { text: "Parcela", value: "parc", align: "center" },
      { text: "Vencimento", value: "vcto", align: "center" },
    ],
  }),
  methods: {
    ...mapGetters("pedidos", [
      "getCondicaoSelecionada",
      "getParcelas",
      "getTipoPedidoSelec",
      "getTxJuros",
    ]),
    isMobile() {
      return this.$mq == "sm";
    },
    formatarData(value) {
      return moment(value).format("DD/MM/YYYY");
    },
    getCtasCorrentes() {
      var ctasFiltradas = this.config.contas;
      if (this.getCondicaoSelecionada().infctacorrente) {
        ctasFiltradas = ctasFiltradas.filter((c) => c.conta != "");
      } else {
        ctasFiltradas = ctasFiltradas.filter((c) => c.conta == "");
      }

      if (this.getCondicaoSelecionada().cartao) {
        ctasFiltradas = ctasFiltradas.filter((c) => c.libcartao);
        this.novopedido.contaSelecionada = ctasFiltradas[0];
      }

      return ctasFiltradas;
    },
    getCondPgtoFiltradas() {
      var condicoes = this.config.condicoespgto.filter(
        (cpgto) =>
          cpgto.tipospedido.findIndex(
            (tp) => tp == this.novopedido.tipoPedidoSelec
          ) >= 0
      );
      if (this.novopedido.cliente.bloq_vendas_prazo) {
        condicoes = condicoes.filter((c) => c.libera_cliente_bloq);
      }
      if (this.novopedido.cliente.pgto_antecipado) {
        condicoes = condicoes.filter((c) => c.libera_pgto_antec);
      }
      return condicoes;
    },
    txJurosCartao() {
      if (this.novopedido.cartaoSelecionado > 0) {
        return `Taxa de juros: ${this.getTxJuros()}%`;
      }

      return "";
    },
    getTipoCartao() {
      if (
        this.getCondicaoSelecionada().cartao &&
        this.getCondicaoSelecionada().qtdparcelas > 1
      ) {
        return this.config.tiposcartoes[0];
      }
      return this.config.tiposcartoes;
    },
    atualizarCondPgto() {
      if (this.getCondPgtoFiltradas().length > 0) {
        //if (this.novopedido.condicaoPgtoSelecionada == 0) {
        this.novopedido.condicaoPgtoSelecionada =
          this.getCondPgtoFiltradas()[0].codigo;
        //}
      }
    },
  },
  created() {
    if (
      this.config.condicoespgto.length > 0 &&
      this.novopedido.condicaoPgtoSelecionada == 0
    ) {
      this.novopedido.condicaoPgtoSelecionada =
        this.getCondPgtoFiltradas()[0].codigo;
    }
    if (
      this.getCtasCorrentes().length > 0 &&
      this.novopedido.contaSelecionada == ""
    ) {
      this.novopedido.contaSelecionada = this.getCtasCorrentes()[0].conta;
    }
  },
};
</script>

<style>
</style>
